export const ignoredLogs = [
    'When setting overflow to hidden on Surface the shadow will not be displayed correctly. Wrap the content of your component in a separate View with the overflow style.',
    'Sending `onAnimatedValueUpdate` with no listeners registered.', //https://github.com/react-navigation/react-navigation/issues/11564
]
